import { MapReportSearchResults } from './MapReportSearchResults'
import { MapReportApi } from '@/api/MapReportApi'
import { MapReportStatuses } from '@/models/MapReport'

export class MapReportListRepository {
  static async getMapReport(keyword, advertiserId, pageNo) {
    try {
      const pageSize = 20
      const res = await MapReportApi.searchForAdvertisers(
        keyword,
        advertiserId,
        pageNo,
        pageSize,
      )
      return MapReportSearchResults.assign(res, pageSize)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async remove(mapReportId) {
    try {
      const res = await MapReportApi.remove(mapReportId)
      return res.status
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async updateName(mapReportId, name) {
    try {
      await MapReportApi.updateName(mapReportId, name)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async getMapReportRequestCountForAdmin() {
    try {
      const query = { status: MapReportStatuses.Waiting }
      const res = await MapReportApi.searchForAdmin(query)
      return res.count
    } catch (e) {
      return 0
    }
  }

  static async getMapReportForAdmin(
    keyword,
    status,
    isAutoGenerated,
    pageNo,
    pageSize = 20,
  ) {
    try {
      const query = { keyword }
      if (status !== MapReportStatuses.All) {
        query['status'] = status
      }
      if (isAutoGenerated !== null) {
        query['isAutoGenerated'] = isAutoGenerated
      }
      const res = await MapReportApi.searchForAdmin(query, pageNo, pageSize)
      return MapReportSearchResults.assign(res, pageSize)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async updateUrl(mapReportId, url) {
    try {
      await MapReportApi.updateUrl(mapReportId, url)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async updateRejectStatus(mapReportId, rejectReason) {
    try {
      await MapReportApi.updateRejectStatus(mapReportId, rejectReason)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async putAutoGenerated(mapReportId, isAutoGenerated) {
    try {
      await MapReportApi.registerAutoGenerated(mapReportId, isAutoGenerated)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async modifyAutoGeneratedStatus(mapReportId, isAutoGeneratedStatus) {
    await this.putAutoGenerated(mapReportId, isAutoGeneratedStatus)
  }
}
